/**
 * 读取cookie
 * @param {string} name cookie项的名字
 */
export function getCookie(name) {
    var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    console.log()
    if (document.cookie.match(reg)) {
        arr = document.cookie.match(reg);
        return unescape(arr[2]);
    } else {
        return null;
    }
}


/**
 * 设置cookie
 * @param {string} c_name 
 * @param {string} value 
 * @param {number} expiredays 
 */
export function setCookie(c_name, value, expiredays) {
    var exdate = new Date();
    exdate.setDate(exdate.getDate() + expiredays);
    document.cookie = c_name + "=" + escape(value) + ";expires=" + exdate.toGMTString() + ";path=/";
}


/**
 * 删除cookie
 * @param {string} name cookie项的名字
 */
export function deleteCookie(name) {
    setCookie(name, "", -1);
}

/**
 * 节流函数
 * @param {Function} fn 
 * @param {Number} awitTIme 
 * @returns 
 */
// export function throttle(fn, awitTIme) {
//   let timer = null
//   return function () {
//     const args = arguments
//     if(!timer) {
//       timer = setTimeout(() => {
//         fn.apply(this, args)
//         timer = null
//       }, awitTIme)
//     }
//   }
// }